import { useCallback, useEffect, useState } from "react";
import { FaPlay, FaTimes } from "react-icons/fa";
import { artemulkImages, promoVideo } from "../../data/artemulkContent";

const buildEmbedUrl = (youtubeId) =>
  `https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0&modestbranding=1`;

/** Arte Mülk tanıtım videosu — youtubeId yoksa bölüm gösterilmez */
const VideoHome = () => {
  const youtubeId = (promoVideo.youtubeId || "").trim();
  const [open, setOpen] = useState(false);
  const [embedUrl, setEmbedUrl] = useState("");

  const close = useCallback(() => {
    setOpen(false);
    setEmbedUrl("");
  }, []);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") close();
    };
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open, close]);

  if (!youtubeId) return null;

  const openVideo = () => {
    setEmbedUrl(buildEmbedUrl(youtubeId));
    setOpen(true);
  };

  return (
    <>
      <section
        className="relative my-10 mx-[3%] md:mx-[6%] rounded-xl overflow-hidden min-h-[260px] flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.55)), url(${artemulkImages.videoBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="w-full p-8 md:p-12 flex flex-wrap items-center gap-10">
          <div className="flex-1 min-w-[240px] flex flex-col items-center">
            <button
              type="button"
              onClick={openVideo}
              className="group relative max-w-md w-full rounded-lg overflow-hidden border-2 border-white/20 shadow-lg focus:outline-none focus:ring-2 focus:ring-primary"
              aria-label="Tanıtım videosunu oynat"
            >
              <img
                src={promoVideo.thumbnail}
                alt="Arte Mülk tanıtım videosu"
                className="w-full aspect-video object-cover"
              />
              <span className="absolute inset-0 flex items-center justify-center">
                <span className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-primary/90 group-hover:bg-[#674921] flex items-center justify-center shadow-lg transition-colors">
                  <FaPlay className="text-white ml-1 text-2xl md:text-3xl" />
                </span>
              </span>
            </button>
            <p className="mt-4 text-white text-center font-semibold">
              Tanıtım Videomuzu İzleyin
            </p>
          </div>
          <div className="flex-1 min-w-[200px]">
            <p className="text-2xl md:text-3xl font-light text-slate-100 text-center md:text-left">
              Beklentilerinizin ötesinde hizmet anlayışımızla yanınızdayız...
            </p>
          </div>
        </div>
      </section>

      {open && embedUrl && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/70"
          role="dialog"
          aria-modal="true"
          aria-label="Tanıtım videosu"
          onClick={close}
        >
          <div
            className="relative w-full max-w-4xl bg-black rounded-xl overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              onClick={close}
              className="absolute top-3 right-3 z-10 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center"
              aria-label="Kapat"
            >
              <FaTimes />
            </button>
            <div className="relative w-full pt-[56.25%]">
              <iframe
                className="absolute inset-0 w-full h-full"
                src={embedUrl}
                title="Arte Mülk tanıtım videosu"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                referrerPolicy="strict-origin-when-cross-origin"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VideoHome;
